import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { getSuperAdminDashboardChartEndpoint as endpoint } from "../apiEndpoint";

const SuperAdminDashboardChartApi = async (type: string) => {
  if (!type) throw new Error("Time period type is required");

  const url = endpoint(type);
  const options: FetchOptions = { method: "GET" };

  return fetchInterceptor(url, options);
};

export default SuperAdminDashboardChartApi;
